import * as Sentry from '@sentry/react'

export const catchWithSentry = (e: any) => {
  if (e.data.statusCode === 500) {
    Sentry.captureException(e)
  }
}
